import { useEffect, useRef, useState } from "preact/hooks";
import type { NumberCopy } from "./content.js";
import { countAt, useInView, useReducedMotion } from "./motion.js";

const DURATION = 1400;

function Figure({ item, run }: { readonly item: NumberCopy; readonly run: boolean }) {
  const [value, setValue] = useState(item.value);
  const reduced = useReducedMotion();
  useEffect(() => {
    if (!run || reduced || item.value === 0) {
      setValue(item.value);
      return;
    }
    const start = performance.now();
    let frame = 0;
    const draw = (now: number) => {
      setValue(countAt(item.value, now - start, DURATION));
      if (now - start < DURATION) {
        frame = requestAnimationFrame(draw);
      }
    };
    setValue(0);
    frame = requestAnimationFrame(draw);
    return () => cancelAnimationFrame(frame);
  }, [run, reduced, item.value]);
  return (
    <div class="num">
      <p class="num-value">
        <span data-testid="num-value">{value}</span>
        {item.unit ? <small>{item.unit}</small> : null}
      </p>
      <p class="num-label">{item.label}</p>
    </div>
  );
}

export function Numbers({ items }: { readonly items: readonly NumberCopy[] }) {
  const root = useRef<HTMLElement>(null);
  const seen = useInView(root, "0px 0px -20% 0px");
  const [armed, setArmed] = useState(false);
  const [run, setRun] = useState(false);
  useEffect(() => setArmed(true), []);
  useEffect(() => {
    if (seen) {
      setRun(true);
    }
  }, [seen]);
  const state = `${armed ? " is-armed" : ""}${run ? " is-run" : ""}`;
  return (
    <section class={`section nums${state}`} ref={root}>
      <div class="wrap nums-grid">
        {items.map((item) => (
          <Figure key={item.label} item={item} run={run} />
        ))}
      </div>
    </section>
  );
}
